import { Pipe, PipeTransform } from '@angular/core';
import { SharedUtilString } from '@luggagehero/shared/util';

@Pipe({ name: 'uppercaseFirstLetter', standalone: true })
export class UppercaseFirstLetterPipe implements PipeTransform {
  transform(value: string, lowercaseTail = false, allWords = false): string {
    return SharedUtilString.uppercaseFirstLetter(value, lowercaseTail, allWords);
  }
}
